export default __webpack_public_path__ + "static/media/1020.32a08837.svg";